var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnverified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8a7 7 0 017-7h4a7 7 0 017 7v4a7 7 0 01-7 7H8a7 7 0 01-7-7V8z",
    fill: "url(#unverified_svg__paint0_linear_20467_42300)",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8a7 7 0 017-7h4a7 7 0 017 7v4a7 7 0 01-7 7H8a7 7 0 01-7-7V8z",
    stroke: "url(#unverified_svg__paint1_linear_20467_42300)",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 5H9v5l1 2 1-2V5zm-1 8a1 1 0 100 2 1 1 0 000-2z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "unverified_svg__paint0_linear_20467_42300",
    x1: 0,
    y1: 9,
    x2: 20,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E72A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05803"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "unverified_svg__paint1_linear_20467_42300",
    x1: 0,
    y1: 9,
    x2: 20,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E72A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05803"
  })))));
}

export default SvgUnverified;